import "./index.css";
import React, { useRef, useEffect, useState } from "react";
import {
  Worker,
  Viewer,
  ViewMode,
  SpecialZoomLevel,
  useIsMounted,
  PrimaryButton,
  RotateDirection,
} from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import AnnotationOverlay from "./AnnotationOverlay";
import debounce from "lodash.debounce";
import { zoomKey } from "./index";
import { getAuthHeader } from "./AuthRoute";
import { rotatePlugin } from "@react-pdf-viewer/rotate";
import {
  RotateBackwardIcon,
  RotateForwardIcon,
} from "@react-pdf-viewer/rotate";

const MyPDFViewer = ({
  pdfUrl,
  fallBackPdfUrl,
  annotations,
  editAnnotation,
  selectAnnotation,
  insertAnnotation,
  deselectAnnotationsInPage,
  zoomPluginInstance,
  depthsVisibility,
  descriptionsVisibility,
  groupAnnotation,
  smartSelect,
}) => {
  const [url, setUrl] = useState(pdfUrl);
  const [useFallBack, setUseFallBack] = useState(false);
  useEffect(() => {
    setUseFallBack(false);
  }, [pdfUrl, fallBackPdfUrl]);
  useEffect(() => {
    if (useFallBack) {
      setUrl(pdfUrl);
    } else {
      setUrl(fallBackPdfUrl);
    }
  }, [pdfUrl, useFallBack]);

  const defaultScale =
    parseFloat(localStorage.getItem(zoomKey)) || SpecialZoomLevel.ActualSize;
  const rotatePluginInstance = rotatePlugin();
  const { RotatePage } = rotatePluginInstance;
  const [pages, setPages] = useState([]);

  const findPages = () => {
    const viewerContainer = document.querySelector(".pdfViewerContainer");
    const pageContainers = viewerContainer.querySelectorAll(
      ".rpv-core__inner-page-container",
    );

    const newPages = Array.from(pageContainers).map((pageContainer, index) => {
      const pageLayer = pageContainer.querySelector(".rpv-core__page-layer");
      const { width, height, top, left } = pageLayer.getBoundingClientRect();
      return { width, height, top, left, index };
    });

    setPages(newPages);
  };

  const debouncedUpdatePageDimensions = debounce(findPages, 100);

  useEffect(() => {
    findPages();
    window.addEventListener("resize", findPages);
    return () => window.removeEventListener("resize", findPages);
  }, []);

  let rotationButtons = (
    <div
      style={{
        position: "absolute",
        top: -21,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        display: "flex",
        gap: "1px",
      }}
    >
      <RotatePage>
        {(props) => (
          <button
            onClick={() => props.onRotatePage(0, RotateDirection.Backward)}
          >
            <RotateBackwardIcon />
          </button>
        )}
      </RotatePage>
      <RotatePage>
        {(props) => (
          <button
            onClick={() => props.onRotatePage(0, RotateDirection.Forward)}
          >
            <RotateForwardIcon />
          </button>
        )}
      </RotatePage>
    </div>
  );
  return (
    <div style={{ top: "100px", width: "100%", position: "relative" }}>
      {rotationButtons}
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
        <div className="pdfViewerContainer">
          <Viewer
            key={pdfUrl + "_" + fallBackPdfUrl} // force re-render on url change
            fileUrl={url}
            httpHeaders={{ Authorization: getAuthHeader() }}
            defaultScale={defaultScale}
            plugins={[zoomPluginInstance, rotatePluginInstance]}
            onZoom={(scale) => {
              debouncedUpdatePageDimensions();
            }}
            renderError={(error) => {
              setUseFallBack(true);
              return (
                <div
                  style={{ width: "100%", textAlign: "center", color: "red" }}
                >
                  <p>
                    Refresh the page, or select the right document on the left
                  </p>
                </div>
              );
            }}
            onDocumentLoad={(e) => {
              console.log(e);
              debouncedUpdatePageDimensions();
            }}
          />
        </div>
      </Worker>
      {/*{pages.map((page) => (*/}
      {/*  <AnnotationOverlay*/}
      {/*    key={page.index}*/}
      {/*    page={page}*/}
      {/*    annotations={annotations}*/}
      {/*    editAnnotation={editAnnotation}*/}
      {/*    selectAnnotation={selectAnnotation}*/}
      {/*    insertAnnotation={insertAnnotation}*/}
      {/*    depthsVisibility={depthsVisibility}*/}
      {/*    descriptionsVisibility={descriptionsVisibility}*/}
      {/*    groupAnnotation={groupAnnotation}*/}
      {/*    smartSelect={smartSelect}*/}
      {/*    deselectAnnotationsInPage={deselectAnnotationsInPage}*/}
      {/*  />*/}
      {/*))}*/}
    </div>
  );
};
export default MyPDFViewer;
